export default __webpack_public_path__ + "static/media/lottery-banners-id.cd3eec18.webp";